module.exports = __webpack_public_path__ + "static/media/kid-1.df133661.png";